import { getLanguageString as _ } from "misc/lang";
import { LoaderUtil } from "misc/loader";
import {
  apiTriggerPasswordReset,
  apiTriggerEmailVerification,
  apiSignInAccessToken,
} from "net/requests";
import { onSignedIn } from "misc/account_utils";
import { LS_ACCESS_TOKEN } from "appConfig";

var ls = require("local-storage");

export const getTriggerPasswordReset = (
  loader: LoaderUtil,
  setError?: (error: string) => void
) => {
  return (email: string) => {
    loader.setLoading();
    apiTriggerPasswordReset(email)
      .then((response) => {
        loader.setResult(
          true,
          _("auth", "trigger_pw_reset_head"),
          _("auth", "trigger_pw_reset_response")
        );
      })
      .catch((error) => {
        loader.reset();
        const errorCode = error.response?.data?.error;
        if (errorCode === "rate-limit-block") {
          setError && setError(_("auth", "trigger_pw_reset_error_rate_limit"));
        } else if (errorCode === "rate-limit-block-24h") {
          setError &&
            setError(_("auth", "trigger_pw_reset_error_rate_limit_24h"));
        } else {
          setError && setError(_("auth", "trigger_pw_reset_error"));
        }
      });
  };
};

export const getTriggerEmailVerification = (
  loader: LoaderUtil,
  setError?: (error: string) => void
) => {
  return (email: string) => {
    loader.setLoading();
    apiTriggerEmailVerification(email)
      .then((response) => {
        loader.setResult(
          true,
          _("user", "trigger_email_verification_response_head"),
          _("user", "trigger_email_verification_response")
        );
      })
      .catch((error) => {
        loader.reset();
        setError && setError(_("user", "trigger_email_verification_error"));
      });
  };
};

export const signInWithAccessToken = (
  accessToken: string,
  props: any,
  defaultOnSuccessNavigation: boolean = true
) => {
  apiSignInAccessToken(accessToken)
    .then((response) => {
      onSignedIn(props, response.data, defaultOnSuccessNavigation);
    })
    .catch((error) => {
      removeAccessToken();
      console.log(error.response?.data?.error);
    });
};

export const storeAccessToken = (accessToken?: string) => {
  ls.set(LS_ACCESS_TOKEN, accessToken || "");
};

export const retrieveAccessToken = (): string | undefined => {
  return ls.get(LS_ACCESS_TOKEN);
};

export const removeAccessToken = () => {
  ls.remove(LS_ACCESS_TOKEN);
};

const defaults = {
  getTriggerPasswordReset,
  getTriggerEmailVerification,
  storeAccessToken,
  retrieveAccessToken,
  removeAccessToken,
  signInWithAccessToken,
};

export default defaults;
